'use strict';

var jQuery = require('jquery');
var select = require('selectric');

jQuery.noConflict();
(function($) {

  /**
   * Languages interaction
   */
  $('.e-dot-wrapper li:first-child').find('.e-dot').addClass('-selected');

  var initParentInfo = (function() {
    var initSelected = $('.-selected').data('lang');
    $('.pi-wrapper').each(function(index, el) {
      if (!$(el).hasClass(initSelected)) {
        $(el).hide();
      }
    });
  })();

  $('.c-parentInfo').on('click', 'li', function() {
    var $this = $(this),
        $button = $this.find('.e-dot'),
        currentLanguage = $button.data('lang'),
        $infoWrapper = $('.c-parentInfo').find($('.pi-wrapper'));

    $('.e-dot').removeClass('-selected');
    $button.addClass('-selected');

    $infoWrapper.each(function() {
      var $i = $(this),
          curILang = $i.hasClass(currentLanguage);

      if (curILang === true) {
        $infoWrapper.hide();
        $i.show();
        return false;
      }
    })
  });


  // mobile menu toggle
  $('.m-nav--toggle').on('click', function() {
      if ($('.m-nav').hasClass('hidden')) {
          $('.m-nav').removeClass('hidden');
      } else {
          $('.m-nav').addClass('hidden');
      }
  });

  // Newspage
  $('#Newspage_section').each(function (index, section) {
    var $section = $(section);
    console.log($section);
    $.getJSON("/umbraco/Surface/News/RenderNews/?no=20&newsid=" + $section.data("newsid"), function (data) {
      console.log(data);
        if ($(data) != null) {
            $(data).each(function (index, item) {
                $('.all', $section).append('<div class="c-news-item item list"><a href="' + item.NiceUrl + '"><img class="news-img" src="' + item.LogoImage + '" /></a>' +
                    '<a href="' + item.NiceUrl + '"><div class="textarea">' +
                    '<h4>' + item.Header + '</h4>' +
                    '<div class="meta">' +
                    '<span class="date">' + item.PublishDate + '</span>' +
                    '</div>' +
                    '<p>' + item.Text + '</p>' +
                    '</div></a>' +
                    '</div>');
            });
        }
    });
  });

  var modal = {
    el: $('.c-modal'),
    btn: $('.modalBtn'),
    body: $('body'),
    span: $('.close')
  };

  modal.btn.on('click', function(){
    modal.el.css('display', 'block');
    modal.body.addClass('modal-open');
    return false;
  });

  modal.span.on('click', function() {
    modal.el.css('display', 'none');
    modal.body.removeClass('modal-open');
  });

  $(window).on('click', function(event) {
    if ($(event.target).attr('class') == 'c-modal') {
      modal.el.css('display', 'none');
      modal.body.removeClass('modal-open');
    }
  });

  $('#registration_app input[type="text"]').on('blur', function(e){ $(e.target).next($('.focus')).slideUp(100); });
  $('#registration_app input[type="text"]').on('focus', function(e){ $(e.target).next($('.focus')).slideDown(100); });
  $('#registration_app textarea').on('blur', function(e){ $(e.target).next($('.focus')).slideUp(100); });
  $('#registration_app textarea').on('focus', function(e){ $(e.target).next($('.focus')).slideDown(100); });


})(jQuery);


/*****************
 ** WEBPACK FOOTER
 ** ./assets_src/js/ui.js
 ** module id = 14
 ** module chunks = 0
 **/